/* eslint-disable @typescript-eslint/no-empty-function */
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import Autocomplete from '@deprecated-ui/common/Autocomplete';
import Input from '@deprecated-ui/common/Input';
import PropTypes from 'prop-types';

const DEFAULT_WIDTH = '100%';
const DEFAULT_HEIGHT = '36px';
const DEFAULT_PLACEHOLDER = 'Type here to search...';

/**
 * Search autocomplete
 * @param {Object} props
 * @param {function} props.onSearch
 * @param {function} props.onSelect
 * @param {function=} props.onChange
 * @param {Array<any>} props.options
 * @param {string=} props.width
 * @param {string=} props.height
 * @param {string=} props.placeholder
 * @param {React.ReactNode=} props.prefix
 * @param {React.ReactNode=} props.suffix
 * @param {boolean=} props.allowClear
 * @param {string=} props.value
 * @param {boolean=} props.open
 */
function SearchAutocomplete({
  onSearch,
  onSelect,
  options,
  width,
  height,
  placeholder,
  prefix,
  ...props
}) {
  return (
    <Autocomplete
      data-testid="search-autocomplete"
      options={options}
      width={width}
      onSearch={onSearch}
      onSelect={onSelect}
      {...props}
    >
      <Input
        prefix={prefix}
        width="100%"
        height={height}
        placeholder={placeholder}
      />
    </Autocomplete>
  );
}

SearchAutocomplete.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  width: PropTypes.string,
  height: PropTypes.string,
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  prefix: PropTypes.node,
};

SearchAutocomplete.defaultProps = {
  options: [],
  width: DEFAULT_WIDTH,
  height: DEFAULT_HEIGHT,
  placeholder: DEFAULT_PLACEHOLDER,
  onSearch: () => {},
  onSelect: () => {},
  prefix: <Iconmoon className="icon-avatar_search" />,
};

export default SearchAutocomplete;
